export function objectWithoutKeys(obj, keys) {
	let result = {};
	for (let i in obj) {
		if (keys.indexOf(i) < 0) {
			result[i] = obj[i];
		}
	}

	return result;
}